import {CultureFitElement, CultureFitElementJSON, CultureFitJSON} from '../types/CultureFitTypes';

export default class CultureFitSerializers {
  static toObject(payload: CultureFitElementJSON): CultureFitElement {
    return {
      resourceId: payload.resource_id,
      key: payload.key,
      percentage: payload.percentage,
      labels: payload.labels,
    };
  }

  static toObjects(payload: CultureFitJSON): CultureFitElement[] {
    return payload.culture_fit.map((culture_fit_element) => CultureFitSerializers.toObject(culture_fit_element));
  }
}
